import { RefreshCw } from 'lucide-react';
import { useFinancialSync, useFinancialSyncStatus } from '../../hooks/useFinancial';
import toast from 'react-hot-toast';

export function SyncButton() {
  const { data: status } = useFinancialSyncStatus();
  const syncMutation = useFinancialSync();

  function handleSync() {
    syncMutation.mutate(undefined, {
      onSuccess: () => toast.success('Sync iniciado'),
      onError: () => toast.error('Erro ao iniciar sync'),
    });
  }

  const isRunning = status?.data?.isRunning || syncMutation.isPending;
  const lastSync = status?.data?.lastSyncAt;

  return (
    <div className="flex items-center gap-3">
      {lastSync && (
        <span className="text-xs text-secondary-400">
          Ultimo sync: {new Date(lastSync).toLocaleString('pt-BR')}
        </span>
      )}
      <button
        onClick={handleSync}
        disabled={isRunning}
        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-lg border border-secondary-300 hover:bg-secondary-50 disabled:opacity-50 transition-colors"
      >
        <RefreshCw className={`w-4 h-4 ${isRunning ? 'animate-spin' : ''}`} />
        {isRunning ? 'Sincronizando...' : 'Sync'}
      </button>
    </div>
  );
}
